export const getDefaultValues = (rtmpAppDetails) => ({
  RtmpAppLabel: rtmpAppDetails?.RtmpAppLabel || '',
});
